import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  async createAdas({ commit, state, dispatch }, data) {
    const r = await startLoading(dispatch, 'createAdas', () => http.post('decode/createAdas', data))
    commit(types.SET_ADAS_IDS, r.data)
    return r.data
  },
  async getAdasInspection({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getAdasInspection', () =>
      http.get(`decode/adasInspection?adasInspection=${id}`)
    )
    commit(types.SET_ADASINSPECTION, r.data)
    return r.data
  },
  async getAdasMatrices({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getAdasMatrices', () =>
      http.get('decode/getAdasMatrix', {
        params: options
      })
    )
    commit(types.SET_ADAS_MATRICES, r.data)
    return r.data
  },
  async getGeneralInfoLinks({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getLinks', () =>
      http.get('decode/getGeneralInfoLinks', {
        params: data
      })
    )
    commit(types.SET_LINKS, r.data)
    return r.data
  },
  async getLinks({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getLinks', () =>
      http.get('decode/getLinks', {
        params: data
      })
    )
    commit(types.SET_LINKS, r.data)
    return r.data
  },
  async decodeVIN({ commit, dispatch }, vin) {
    const r = await startLoading(dispatch, 'decodeVIN', () => http.get(`decode/vin?vin=${vin}`))
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/adas/actions.js